export const DISPLAY_MODE = {
    REGULAR_LOAN: 'REGULAR_LOAN',
    PAYMENT_PLAN_ACTIVE: 'PAYMENT_PLAN_ACTIVE',
    PAYMENT_PLAN_DELINQUENT: 'PAYMENT_PLAN_DELINQUENT',
    PAYMENT_PLAN_BROKEN: 'PAYMENT_PLAN_BROKEN',
    PAYMENT_PLAN_COMPLETED: 'PAYMENT_PLAN_COMPLETED',
    PAYMENT_PLAN_CANCELED: 'PAYMENT_PLAN_CANCELED',
};

const OPERATIONAL_PAYMENT_PLAN_MODES = [
    DISPLAY_MODE.PAYMENT_PLAN_ACTIVE,
    DISPLAY_MODE.PAYMENT_PLAN_DELINQUENT,
];

/**
 * Resolve display mode from BFF payload with safe fallback.
 */
export function resolveDisplayMode(data) {
    return data?.display_mode ?? DISPLAY_MODE.REGULAR_LOAN;
}

export function isActivePaymentPlanMode(displayMode) {
    return displayMode === DISPLAY_MODE.PAYMENT_PLAN_ACTIVE;
}

export function isDelinquentPaymentPlanMode(displayMode) {
    return displayMode === DISPLAY_MODE.PAYMENT_PLAN_DELINQUENT;
}

/**
 * Plan is still in effect (ACTIVE or DELINQUENT) — commitments remain collectible.
 */
export function isOperationalPaymentPlanMode(displayMode) {
    return OPERATIONAL_PAYMENT_PLAN_MODES.includes(displayMode);
}

export function isTerminalPaymentPlanMode(displayMode) {
    return [
        DISPLAY_MODE.PAYMENT_PLAN_BROKEN,
        DISPLAY_MODE.PAYMENT_PLAN_COMPLETED,
        DISPLAY_MODE.PAYMENT_PLAN_CANCELED,
    ].includes(displayMode);
}

/**
 * Default empty summary when BFF omits payment_plan_summary (backward compatible).
 */
export function normalizePaymentPlanSummary(summary) {
    if (!summary || typeof summary !== 'object') {
        return {
            has_active_payment_plan: false,
            active_payment_plans_count: 0,
            delinquent_payment_plans_count: 0,
            broken_payment_plans_count: 0,
            total_payment_plan_pending: '0.00',
            next_payment_plan_due_date: null,
            next_payment_plan_due_amount: null,
            payment_plans: [],
        };
    }

    return summary;
}

export function hasDelinquentPaymentPlans(summary) {
    const normalized = normalizePaymentPlanSummary(summary);

    if ((normalized.delinquent_payment_plans_count ?? 0) > 0) {
        return true;
    }

    return (normalized.payment_plans ?? []).some((entry) => entry?.status === 'DELINQUENT');
}
